var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCheckedIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 7,
    viewBox: "0 0 8 7",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.65883 1.31331C7.65883 1.428 7.61164 1.53799 7.52764 1.61909L3.05407 5.93812C3.01252 5.97834 2.96315 6.01025 2.9088 6.03203C2.85445 6.0538 2.79619 6.06501 2.73735 6.06501C2.6785 6.06501 2.62024 6.0538 2.56589 6.03203C2.51154 6.01025 2.46217 5.97834 2.42062 5.93812L0.631193 4.21051C0.547192 4.12941 0.5 4.01941 0.5 3.90472C0.5 3.79003 0.547192 3.68004 0.631193 3.59894C0.715195 3.51784 0.829125 3.47227 0.947921 3.47227C1.06672 3.47227 1.18065 3.51784 1.26465 3.59894L2.73735 5.02162L6.89418 1.00752C6.97818 0.926421 7.09211 0.880859 7.21091 0.880859C7.3297 0.880859 7.44363 0.926421 7.52764 1.00752C7.61164 1.08862 7.65883 1.19862 7.65883 1.31331Z",
    fill: "#1672EC"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckedIcon);
export default __webpack_public_path__ + "static/media/checkedIcon.5c27490c.svg";
export { ForwardRef as ReactComponent };